import { COMPANY_TYPES } from '../../../../../../../constants';
import { LoanApplication } from '../../../../../../../modules/loan';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const {
  forProfitCompanyType,
  nonProfitOrganizationType,
  industryBorrowerReported,
} = loanFormModel.formField;

/** True when inferred borrower company type is Property Company (PropCo rent collector). */
class IsBorrowerTypePropertyCompany implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    return (
      LoanApplication.getBusinessType({
        forProfitCompanyType: application[forProfitCompanyType.name],
        nonProfitOrganizationType: application[nonProfitOrganizationType.name],
        industryBorrowerReported: application[industryBorrowerReported.name],
      }) === COMPANY_TYPES.PROPERTY_COMPANY
    );
  }
}

export default new IsBorrowerTypePropertyCompany();
